<section class="section section-md section-shaped">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="title" [innerHTML]="'raise.myApplications' | translate"></div>
      </div>
      <div class="col-lg-6 col-md-12 d-flex align-items-center justify-content-lg-end new-btn-wrap">
        <div class="btn btn-primary new-btn" routerLink="/raise/raise-fund-form">
          {{ 'raise.newApplication' | translate }}
        </div>
      </div>
    </div>
    @if (fundRaiseApplications && fundRaiseApplications.length > 0) {
      <div class="row mt-3">
        <div class="col-lg-6">
          <div class="input-label input-md">{{ 'raise.selectApplication' | translate }}</div>
          <div class="input-field input-md">
            <mat-select
              [placeholder]="'common.selectPlaceholder' | translate"
              class="form-control select-app"
              [(ngModel)]="applicationId"
              (selectionChange)="getApplicationProgress(true)"
            >
              @for (application of fundRaiseApplications; track application) {
                <mat-option class="long-text-option" [value]="application.id">
                  {{ application.name }}
                </mat-option>
              }
            </mat-select>
          </div>
        </div>
      </div>
    }
    @if (!fundRaiseApplications) {
      <agmo-loading></agmo-loading>
    }
  </div>
  <div class="container-fluid mt-4">
    @if (
      selectedFundRaiseProcess &&
      selectedApplication.campaignStatus != CampaignStatus.Rejected &&
      !selectedApplication.isLegacySystem
    ) {
      <div class="tab-panel">
        @for (content of tabContents; track content) {
          <div class="tab-item d-flex" [class.active]="selectedTab === content.tab">
            <a (click)="changeTab(content)">{{ content.name | translate }}</a>
            @if (content.hoverText) {
              <div
                class="hover-dropdown"
                ngbDropdown
                (click)="$event.stopPropagation(); $event.preventDefault()"
              >
                <!--Waiting designer to provide white icon for active tab-->
                <div
                  class="pitchin-icon pitchin-icon-info-icon-grey ml-2 no-caret"
                  ngbDropdownToggle
                ></div>
                <div class="font-size-smaller p-3 hover-text-panel" ngbDropdownMenu>
                  {{ content.hoverText | translate }}
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="mt-2">
        <!-- <app-application-process-list *ngIf="!isLoading" [fundRaiseProcess]="selectedFundRaiseProcess" [tabContent]="selectedTabContent"
        [fundRaiseApplicationId]="applicationId" (next)="next(selectedTab)"
      (refresh)="getApplicationProgress()" [campaignCreated]="campaignCreated"></app-application-process-list> -->
        @if (!isLoading) {
          <app-process-list
            [fundRaiseProcess]="selectedFundRaiseProcess"
            [tabContent]="selectedTabContent"
            [fundRaiseApplicationId]="applicationId"
            (next)="next(selectedTab)"
            (refresh)="getApplicationProgress()"
            [campaignCreated]="campaignCreated"
          >
          </app-process-list>
        }
        @if (isLoading) {
          <agmo-loading></agmo-loading>
        }
      </div>
    }
    @if (fundRaiseApplications && fundRaiseApplications.length == 0) {
      {{ 'raise.noApplication' | translate }}
    }
    @if (selectedApplication && selectedApplication.campaignStatus == CampaignStatus.Rejected) {
      <div class="pb-2">
        {{ 'raise.rejectedApplication' | translate }}
      </div>
      <div class="font-weight-bold text-black">
        {{ selectedApplication.remark }}
      </div>
    }
    @if (
      selectedApplication &&
      selectedApplication.campaignStatus != CampaignStatus.Rejected &&
      selectedApplication.isLegacySystem
    ) {
      <div class="pb-2">
        {{ 'raise.findCampaignDetails' | translate }}
      </div>
      <div class="btn btn-primary" [routerLink]="['/equity', selectedApplication.slug]">
        {{ 'raise.viewCampaignDetails' | translate }}
      </div>
    }
  </div>
</section>
